import React from "react";
import {Modal} from 'antd';
import getSize from "../../../../utils/getSize";
import NHFetch from "../../../../utils/NHFetch";
import css from './index.css';
import JxXsxxcjcx from "../jxXsxxcjcx";//基线
import GwyXsxxcjcx from "../gwyXsxxcjcx";//广外艺

const confirm = Modal.confirm;

const baseUrlPath = "/yxxt"; //基础路径

class index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menuCode: [],//null是基线
        };
    }

    componentDidMount() {
        this.getMenuCode();
    }

    getMenuCode = () => {
        let cds = ["xsxxcjcx"];
        NHFetch(baseUrlPath + '/getXmdcd', 'POST', cds).then(res => {
            if (res) {
                if (res && res.code == 200) {
                    let menuCode = res.data;
                    this.setState({
                        menuCode
                    })
                }
            }
        });
    }

    render() {
        const {menuCode} = this.state;
        return (
          <div>
              {
                  menuCode && menuCode.length > 0 && menuCode.map((item, index) => {
                      if (item.JC == "gwy") {
                          return <GwyXsxxcjcx/>
                      } else {
                          return <JxXsxxcjcx/>
                      }
                  })
              }
              {(menuCode == null || menuCode.length == 0) && <JxXsxxcjcx/>}
          </div>
        );
    }
}

export default index;



// WEBPACK FOOTER //
// ./components/tjcx/xsxxcjcx/tyXsxxcjcx/index.js